(function () {
    'use strict';

    function main() {
        var pageController = {
            init: function () {
                WhistleOut.getAds('MobilePhones');
            }
        };

        pageController.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
